import React from "react";
import flowers from "../data/compozitiiCutie";
import FlowerContainer from "../components/FlowerContainer";

const CompozitiiCutie = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Compoziții in coșuri și cutii"
      subtitle="Alege un aranjament sofisticat, prezentat în coșuri sau cutii elegante, pentru un cadou memorabil."
      storageKey="COMPOZITII_CUTIE_SCROLL_POSITION"
    />
  );
};

export default CompozitiiCutie;
